import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useLocation,
} from "react-router-dom";
import { useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import Dashboard from "./components/Dashboard";
import PlayerStats from "./components/PlayerStats";
import PlayerDetail from "./components/PlayerDetail";
import TeamStats from "./components/TeamStats";
import TeamDetail from "./components/TeamDetail";
import IndividualTournaments from "./components/IndividualTournaments";
import LeagueDetails from "./components/LeagueDetails";
import MatchResults from "./components/MatchResults";
import NewsList from "./components/NewsList";
import NewsDetail from "./components/NewsDetail";
import TournamentSchedule from "./components/TournamentSchedule";
import TournamentRegistration from "./components/TournamentRegistration";
import PWAUpdateNotification from "./components/PWAUpdateNotification";
import InstallPWA from "./components/InstallPWA";
import AdPopup from "./components/AdPopup";
import Universe from "./components/Universe";

// Mobile Bottom Navigation Component
function BottomNav() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const isLeagueActive = ["/league-details", "/match-results", "/universe"].includes(location.pathname);
  const isMoreActive = ["/teams", "/tournaments", "/news"].some((path) => location.pathname.startsWith(path));
  const closeMenu = () => setOpenMenu(null);

  return (
    <>
      {openMenu === "league" && (
        <div className="bottom-nav-panel" role="menu" aria-label="Giải đấu">
          <NavLink to="/match-results" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">⚔</span>
            <span>Lịch thi đấu</span>
          </NavLink>
          <NavLink to="/league-details" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">🏆</span>
            <span>Bảng xếp hạng</span>
          </NavLink>
          <NavLink to="/universe" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">◎</span>
            <span>Dự đoán</span>
          </NavLink>
          <a href="https://admin.bongbanhadong.com" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">🏓</span>
            <span>Quản lý giải đấu</span>
          </a>
        </div>
      )}

      {openMenu === "more" && (
        <div className="bottom-nav-panel" role="menu" aria-label="Thêm">
          <NavLink to="/teams" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">👥</span>
            <span>Đội</span>
          </NavLink>
          <NavLink to="/tournaments" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">🏓</span>
            <span>Giải Đơn Đôi</span>
          </NavLink>
          <NavLink to="/news" onClick={closeMenu} className="bottom-nav-panel-item">
            <span className="bottom-nav-panel-icon">▤</span>
            <span>Tin tức</span>
          </NavLink>
        </div>
      )}

      <nav className="bottom-nav" aria-label="Menu mobile">
      <NavLink to="/" onClick={closeMenu} className={({ isActive }) => `bottom-nav-item ${isActive ? "active" : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="bottom-nav-icon"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
        <span className="bottom-nav-label">Home</span>
      </NavLink>
      <NavLink to="/dashboard" onClick={closeMenu} className={({ isActive }) => `bottom-nav-item ${isActive ? "active" : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="bottom-nav-icon"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>
        <span className="bottom-nav-label">Tổng quan</span>
      </NavLink>
      <button
        type="button"
        className={`bottom-nav-item bottom-nav-button ${isLeagueActive || openMenu === "league" ? "active" : ""}`}
        aria-expanded={openMenu === "league"}
        onClick={() => setOpenMenu(openMenu === "league" ? null : "league")}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="bottom-nav-icon"><rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
        <span className="bottom-nav-label">Giải đấu</span>
      </button>
      <NavLink to="/players" onClick={closeMenu} className={({ isActive }) => `bottom-nav-item ${isActive ? "active" : ""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="bottom-nav-icon"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
        <span className="bottom-nav-label">VĐV</span>
      </NavLink>
      <button
        type="button"
        className={`bottom-nav-item bottom-nav-button ${isMoreActive || openMenu === "more" ? "active" : ""}`}
        aria-expanded={openMenu === "more"}
        onClick={() => setOpenMenu(openMenu === "more" ? null : "more")}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="bottom-nav-icon"><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /><circle cx="5" cy="12" r="1" /></svg>
        <span className="bottom-nav-label">Thêm</span>
      </button>
      </nav>
    </>
  );
}

function MainContent() {
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "/home";
  const routes = (
    <Routes>
      <Route path="/" element={<Universe mode="home" />} />
      <Route path="/home" element={<Universe mode="home" />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/league-details" element={<LeagueDetails />} />
      <Route path="/match-results" element={<MatchResults />} />
      <Route path="/players" element={<PlayerStats />} />
      <Route path="/players/:id" element={<PlayerDetail />} />
      <Route path="/teams" element={<TeamStats />} />
      <Route path="/teams/:id" element={<TeamDetail />} />
      <Route path="/tournaments" element={<IndividualTournaments />} />
      <Route path="/register-tournament/:uuid" element={<TournamentRegistration />} />
      <Route path="/tournament-schedule/:uuid" element={<TournamentSchedule />} />
      <Route path="/universe" element={<Universe />} />
      <Route path="/news" element={<NewsList />} />
      <Route path="/news/:id" element={<NewsDetail />} />
    </Routes>
  );

  if (isHome) return routes;
  return <Container className="mt-4">{routes}</Container>;
}

function AppOverlays() {
  const location = useLocation();
  if (location.pathname === "/" || location.pathname === "/home") return null;

  return (
    <>
      <AdPopup />
      <InstallPWA />
      <PWAUpdateNotification />
    </>
  );
}


function AppShell() {
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "/home";

  return (
    <>
      {/* Mobile Header */}
      {!isHome && (
        <div className="d-lg-none py-2 bg-white border-bottom fixed-top px-3 d-flex align-items-center" style={{ zIndex: 1020, height: '60px' }}>
          <img
            src="https://s3.cloudfly.vn/player-images/logo/logo.png"
            alt="Bóng Bàn Hà Đông"
            className="navbar-logo"
            style={{ height: '36px', width: 'auto' }}
          />
          <span className="ms-2 fw-bold text-dark small text-uppercase letter-spacing-1">HDSPL</span>
        </div>
      )}

      {!isHome && (
        <Navbar expand="lg" className="navbar d-none d-lg-flex sticky-top">
          <Container>
            <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center p-0">
              <div className="bg-white p-1 rounded-3 shadow-soft me-2" style={{ border: '1px solid var(--border)' }}>
                <img
                  src="https://s3.cloudfly.vn/player-images/logo/logo.png"
                  alt="Bóng Bàn Hà Đông"
                  style={{ height: '38px', width: 'auto' }}
                />
              </div>
              <div className="d-flex flex-column">
                <span className="fw-800 text-dark lh-1" style={{ fontSize: '1.05rem' }}>HDSPL</span>
                <span className="text-muted fw-600" style={{ fontSize: '0.72rem', textTransform: 'uppercase' }}>Hà Đông Superleague</span>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={NavLink} to="/" end className="px-3">
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink} to="/dashboard" className="px-3">
                  Tổng Quan
                </Nav.Link>
                <NavDropdown title="Giải đấu" id="league-nav-dropdown" className="px-2">
                  <NavDropdown.Item as={NavLink} to="/league-details">
                    Bảng xếp hạng
                  </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/match-results">
                  Lịch thi đấu
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/universe">
                  Dự đoán
                </NavDropdown.Item>
                <NavDropdown.Item href="https://admin.bongbanhadong.com">
                  Quản lý giải đấu
                </NavDropdown.Item>
              </NavDropdown>
                <Nav.Link as={NavLink} to="/players" className="px-3">
                  Vận Động Viên
                </Nav.Link>
                <Nav.Link as={NavLink} to="/teams" className="px-3">
                  Đội
                </Nav.Link>
                <Nav.Link as={NavLink} to="/tournaments" className="px-3">
                  Giải Đơn Đôi
                </Nav.Link>
              <Nav.Link as={NavLink} to="/news" className="px-3">
                Tin Tức
              </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
      <MainContent />
      <BottomNav />
      <AppOverlays />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router >
  );
}

export default App;
